var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.currentRouteName != 'lineitem' && _vm.currentRouteName != 'test')?_c('HeaderView'):_vm._e(),_c('router-view'),(_vm.currentRouteName != 'lineitem' && _vm.currentRouteName != 'test')?_c('FooterView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }